import { Button, Icon, ModuleHeaderSlot, Stack } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useFavoriteArticlesStore } from "../store"

type Props = {
    onCloseDetails: () => void
}
export function Areas({ onCloseDetails }: Props) {
    const { translateText } = useLocalization()
    const { selectedCompilation, setSelectedCompilation } = useFavoriteArticlesStore()

    function handleCloseDetails() {
        setSelectedCompilation()
        onCloseDetails()
    }

    return (
        <ModuleHeaderSlot title={translateText(176)}>
            <Stack direction="row" gap={0.5}>
                <Button onClick={handleCloseDetails} color={!selectedCompilation ? "primary" : undefined} startIcon={<Icon name="menu" />}>
                    {translateText(6)}
                </Button>
                <Button disabled={!selectedCompilation} color={selectedCompilation ? "primary" : undefined} startIcon={<Icon name="details" />}>
                    {translateText(43)}
                </Button>
            </Stack>
        </ModuleHeaderSlot>
    )
}
